import { useMemo } from "react";
import { DateType } from "src/globalTypes";
import { useFormattedMsg } from "../../../../hooks/useFormatMsg";
import { useLocalizationString } from "../../../../store/localization/useSelectors";
import { DateConfig } from "../../../organisms/TableData/types";
import { DateViewFormat } from "./FlowioDateInput";
import {
  getConstraints,
  useGetDateFormat,
  useHelperText,
  usePlaceholder,
} from "./utils";

export type ConstraintsType = { min: string; max: string };
type DateBaseConfigurationType = {
  constraints: ConstraintsType;
  placeholder: string;
  dateFormat: string;
  ampm: boolean;
  isDayOnlyFormat: boolean;
  helperText: string | null;
  clearLabel: string;
  cancelLabel: string;
};

const useDateConfiguration = (
  dateViewFormat: DateViewFormat,
  value: DateType | undefined,
  config?: DateConfig
): DateBaseConfigurationType => {
  const clearLabel = useFormattedMsg("calender.clear");
  const cancelLabel = useFormattedMsg("calender.cancel");
  const localization = useLocalizationString();
  const getDateFormat = useGetDateFormat();

  const ampm = localization !== "cs";
  const isDayOnlyFormat = dateViewFormat === "day only";
  const placeholder = usePlaceholder(dateViewFormat);
  const dateFormat = getDateFormat(dateViewFormat);

  const constraintsFactory = (): ConstraintsType => getConstraints(config);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const constraints = useMemo(constraintsFactory, [config?.min, config?.max]);

  const helperText = useHelperText(value, constraints);

  return {
    constraints,
    placeholder,
    ampm,
    dateFormat,
    isDayOnlyFormat,
    helperText,
    cancelLabel,
    clearLabel,
  };
};

export default useDateConfiguration;
